import { Trans, useTranslation } from 'react-i18next';

import { Button } from '../../../Shared/UI/Button';
import { Charity } from '../../types';

export interface RecurringDonationsTermsProps {
  charity: Charity;
  onAccept: () => void;
  onRefuse: () => void;
  loading?: boolean;
}

export default function RecurringDonationsTerms({
  charity,
  onAccept,
  onRefuse,
  loading,
}: RecurringDonationsTermsProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h3 className="py-1">
          {t('backend:accept_recurring_donations')}
        </h3>
        <div className="space-y-4">
          <p>
            {t('backend:recurring_donations_description', { charity: charity.title })}
          </p>
          <div>
            <h4 className="font-medium text-slate-500 mb-2">
              {t('backend:recurring_supporta_fee')}
            </h4>
            <div className="bg-blue-100 px-4 py-3 rounded-lg text-blue-700 flex justify-between items-end">
              <div>
                <Trans i18nKey="backend:recurring_donations_pricing">
                  <span className="text-2xl font-light" />
                </Trans>
              </div>
              <div className="text-sm text-slate-400 pb-0.5">
                {t('backend:recurring_donations_pricing_including_vat')}
              </div>
            </div>
          </div>
          <p className="text-slate-700">
            <Trans i18nKey="backend:recurring_donations_terms">
              <a href={`https://supporta.com/${charity.locale}/terms`} target="_blank" rel="nooper noreferrer" />
            </Trans>
          </p>
        </div>
      </div>
      <hr />
      <div className="space-x-2 text-right">
        <Button onClick={() => onRefuse()} variant="secondary" disabled={loading}>
          {t('shared:confirmation.cancel')}
        </Button>
        <Button onClick={() => onAccept()} disabled={loading}>
          {t('shared:confirmation.confirm')}
        </Button>
      </div>
    </div>
  );
}
